<main-app-header></main-app-header>

<div class="container py-4">
  <h2 class="mb-4">Industry News</h2>

  <div class="list-group">
    <div
      *ngFor="let a of articles"
      class="list-group-item mb-3 shadow-sm border rounded"
    >
      <div class="news-item">
        <!-- Left: image -->
        <div class="news-image" *ngIf="a.imageUrl">
          <img
            [src]="a.imageUrl"
            [alt]="a.imageAlt || a.title"
            loading="lazy"
            referrerpolicy="no-referrer"
          />
        </div>

        <!-- Right: content -->
        <div class="news-content">
          <h5 class="mb-2">{{ a.title }}</h5>

          <div class="mt-2">
            <div class="mt-2 bluf-text mb-3">
              {{ a.bluf }}
            </div>
          </div>

          <div class="small text-muted mb-2">
            <div *ngIf="a.author">
              <strong>Author:</strong> {{ a.author }}
            </div>
            <div>
              <strong>Publication:</strong> {{ a.publication }}
            </div>
            <div *ngIf="a.issue">
              <strong>Issue:</strong> {{ a.issue }}
            </div>
            <div class="text-break">
              <strong>URL:</strong> {{ a.url }}
            </div>
            <div>
              <strong>Last Accessed:</strong> {{ a.lastAccessed }}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
